var render = function render(){var _vm=this,_c=_vm._self._c;return _c('baseLogPage',{attrs:{"uploadType":66,"tabName":"销售线索导入历史","downloadFileName":"销售线索导入失败"}})
}
var staticRenderFns = []

export { render, staticRenderFns }